import { graphql } from '@repo/api-kit/graphql';

export const SUBSCRIPTION_CHANGE_ESTIMATE = graphql(`
  query SubscriptionChangeEstimate(
    $input: QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeRequestInput
  ) {
    subscriptionChangeEstimate(input: $input) {
      basketId
      billingMilestones {
        date
        isNegative
        subtitle
        billingTags
        amount {
          value
          currency
        }
      }
      currentCoreSubscription {
        productId
        marketingContent {
          productId
          brandName
          features {
            name
            isUpsell
          }
        }
      }
      errors {
        code
        detail
        additionalData
      }
      isEligibleForVoucherCode
      priceBreakdown {
        blocks {
          section
          items {
            title
            subTitle
            isNegative
            amount {
              value
              currency
            }
          }
        }
        total {
          title
          isNegative
          amount {
            value
            currency
          }
        }
      }
      suggestedSubscriptions {
        productId
        productType
        productCode
        productGroupCode
        recurrence
        basePrice {
          value
          currency
        }
        discountedPrice {
          value
          currency
        }
        specialOffers {
          type
          endDate
          properties
          price {
            value
            currency
          }
        }
        marketingContent {
          productId
          brandName
          features {
            name
            isUpsell
          }
        }
        isRequired
        isComparable
        flow
      }
      targetSubscriptions {
        productId
        productType
        productCode
        productGroupCode
        recurrence
        basePrice {
          value
          currency
        }
        discountedPrice {
          value
          currency
        }
        specialOffers {
          type
          endDate
          properties
          price {
            value
            currency
          }
        }
        marketingContent {
          productId
          brandName
          features {
            name
            isUpsell
          }
        }
        isRequired
        isComparable
        flow
      }
      warnings {
        code
        detail
        additionalData
      }
    }
  }
`);
